// import React, { useState, useEffect } from "react";
// import PropTypes from "prop-types";
// import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
// import { withTranslation } from "react-i18next";
// import { connect } from "react-redux";
// import { Link } from "react-router-dom";
// import withRouter from "components/Common/withRouter";

// const ProfileMenu = (props) => {
//   const [menu, setMenu] = useState(false);
//   const [username, setUsername] = useState("");
//   const [selectedOption, setSelectedOption] = useState("Vulnerability Management"); // Default to a specific option
//   const [isModalOpen, setIsModalOpen] = useState(false); // State for modal visibility

//   useEffect(() => {
//     if (localStorage.getItem("authUser")) {
//       if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
//         const obj = JSON.parse(localStorage.getItem("authUser"));
//         setUsername(obj.displayName);
//       } else if (
//         process.env.REACT_APP_DEFAULTAUTH === "fake" ||
//         process.env.REACT_APP_DEFAULTAUTH === "jwt"
//       ) {
//         const obj = JSON.parse(localStorage.getItem("authUser"));
//         setUsername(obj.username);
//       }
//     }
//   }, [props.success]);

//   // Handle option selection
//   const handleOptionSelect = (option) => {
//     setSelectedOption(option); // Update the selected option
//     if (props.onSelectOption) {
//       props.onSelectOption(option); // Pass the selected option back to the parent
//     }

//     // Trigger the modal if the selected option is "Compliance" or "Third Party Risk"
//     if (option === "Compliance and Data Regulation" || option === "Third Party Risk Management") {
//       setIsModalOpen(true); // Show the modal when one of these options is selected
//     }
//   };

//   // Define style for bigger and bolder text in header
//   const headerTextStyle = {
//     fontSize: "1rem" // Increase font size
//   };

//   // Define the options for the dropdown
//   const options = [
//     "Vulnerability Management",
//     "Compliance and Data Regulation",
//     "Third Party Risk Management"
//   ];

//   // Toggle modal and reset selected option to 'Vulnerability Management' after closing
//   const toggleModal = () => {
//     setIsModalOpen(!isModalOpen);

//     // Reset selected option to "Vulnerability Management" when modal closes
//     if (isModalOpen) {
//       setSelectedOption("Vulnerability Management");
//     }
//   };

//   return (
//     <React.Fragment>
//       <Dropdown
//         isOpen={menu}
//         toggle={() => setMenu(!menu)}
//         className="d-inline-block"
//       >
//         <DropdownToggle
//           className="btn header-item"
//           id="page-header-user-dropdown"
//           tag="button"
//         >
//           <span className="d-none d-xl-inline-block ms-2 me-1" style={headerTextStyle}>
//             {selectedOption} {/* Make selected option bold and larger */}
//           </span>
//           <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
//         </DropdownToggle>
//         <DropdownMenu className="dropdown-menu-end">
//           {/* Map through the options and render only the ones that are not selected */}
//           {options.map((option) => {
//             if (option !== selectedOption) {
//               return (
//                 <React.Fragment key={option}>
//                   <DropdownItem onClick={() => handleOptionSelect(option)}>
//                     <i className="bx bx-tick font-size-16 align-middle me-1" />
//                     {props.t(option)}
//                   </DropdownItem>
//                   <div className="dropdown-divider" />
//                 </React.Fragment>
//               );
//             }
//             return null; // Skip rendering the selected option
//           })}
         
//         </DropdownMenu>
//       </Dropdown>

//       {/* Modal for the pop-up */}
//       <Modal isOpen={isModalOpen} toggle={toggleModal} centered>
//         <ModalHeader toggle={toggleModal}>Feature Under Development</ModalHeader>
//         <ModalBody>
//           <p>We are currently enhancing this feature to better serve your needs. Please check back later for updates.</p>
//         </ModalBody>
//         <ModalFooter>
//           <Button color="secondary" onClick={toggleModal}>Close</Button>
//         </ModalFooter>
//       </Modal>
//     </React.Fragment>
//   );
// };

// ProfileMenu.propTypes = {
//   success: PropTypes.any,
//   t: PropTypes.any,
//   onSelectOption: PropTypes.func, // New prop to handle option selection
// };

// const mapStatetoProps = (state) => {
//   const { error, success } = state.Profile;
//   return { error, success };
// };

// export default withRouter(
//   connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
// );

import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import withRouter from "components/Common/withRouter";

const ProfileMenu = (props) => {
  const [menu, setMenu] = useState(false);
  const [username, setUsername] = useState("");
  const [selectedOption, setSelectedOption] = useState("Compliance and Data Regulation");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        setUsername(obj.displayName);
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === "fake" ||
        process.env.REACT_APP_DEFAULTAUTH === "jwt"
      ) {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        setUsername(obj.username);
      }
    }
  }, [props.success]);

  // Handle option selection
  const handleOptionSelect = (option) => {
    

    // Handle different options
    if (option === "Vulnerability Management") {
      // Open the external website without changing the selected option
      window.location.href = "https://dashboard.bluhawk.live";  // Use the full URL to the external domain
    }
  };

  const headerTextStyle = {
    fontSize: "1rem"
  };

  const options = [
    "Vulnerability Management",
    "Compliance and Data Regulation"
  ];

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item"
          id="page-header-user-dropdown"
          tag="button"
        >
          <span className="d-none d-xl-inline-block ms-2 me-1" style={headerTextStyle}>
            {selectedOption}
          </span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          {options.map((option) => {
            if (option !== selectedOption) {
              return (
                <React.Fragment key={option}>
                  <DropdownItem onClick={() => handleOptionSelect(option)}>
                    <i className="bx bx-tick font-size-16 align-middle me-1" />
                    {props.t(option)}
                    {option === "Vulnerability Management" }
                  </DropdownItem>
                </React.Fragment>
              );
            }
            return null;
          })}
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
  onSelectOption: PropTypes.func,
};

const mapStatetoProps = (state) => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);

